import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { EditOutlined, DownloadOutlined } from '@ant-design/icons'
import { message } from 'antd'
import useCustomHistory from '@/hooks/useCustomHistory'
import ModalGuide from '@/components/ModalGuide'
import { exportMediaAnswerMarking } from '@/apis/validationAPI'
import {
  Container,
  CaptionTagWrapper,
  Caption,
  CodeWrapper,
  TagWrapper,
  RouteWrapper,
  SurveyListText,
  AntRightOutlined,
  ValidationListText,
  HeaderActions,
  ActionLink,
  Text
} from './styles'

const CaptionEnrollment = ({ data }) => {
  const { t } = useTranslation()
  const { navigateToPage } = useCustomHistory()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isExporting, setIsExporting] = useState(false)

  const goBackToSurvey = () => {
    navigateToPage('/dashboard')
  }

  const onToggleModal = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleExport = async () => {
    if (!data?._id) {
      return
    }

    try {
      setIsExporting(true)
      await exportMediaAnswerMarking(data._id, data.name)
      message.success('Media answer marks exported successfully')
    } catch (error) {
      message.error('Unable to export media answer marks, please try again')
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <>
      <Container>
        <div>
          <CaptionTagWrapper>
            <Caption>
              {t('components.survey.entries.header')} ({data.name})
            </Caption>
            <TagWrapper>
              <Text>{t('components.survey.entries.live')}</Text>
            </TagWrapper>
          </CaptionTagWrapper>

          {data.management && <CodeWrapper>{data.management.code}</CodeWrapper>}

          <RouteWrapper>
            <SurveyListText onClick={goBackToSurvey}>
              {t('components.survey.entries.list')}
            </SurveyListText>
            <AntRightOutlined />
            <ValidationListText>
              {t('components.survey.entries.header')}
            </ValidationListText>
          </RouteWrapper>
        </div>
        <HeaderActions>
          <ActionLink onClick={handleExport} disabled={isExporting || !data?._id}>
            <span>{isExporting ? 'Exporting...' : 'Export media marks'}</span>
            <DownloadOutlined />
          </ActionLink>
          <ActionLink onClick={onToggleModal}>
            <span>Edit support guide</span>
            <EditOutlined />
          </ActionLink>
        </HeaderActions>
      </Container>

      <ModalGuide survey={data} open={isModalOpen} onClose={onToggleModal} />
    </>
  )
}

export default CaptionEnrollment
